/* Akcje zarządzające wyświetlaniem zakładek */
export const TABS_INIT = 'DYNAMIC_TABS/TABS_INIT';
export const TABS_CLOSE_ALL = 'DYNAMIC_TABS/TABS_CLOSE_ALL';

export const TAB_OPEN_NEW = 'DYNAMIC_TABS/TAB_OPEN_NEW';
export const TAB_CLOSE = 'DYNAMIC_TABS/TAB_CLOSE';
export const TAB_SET_ACTIVE = 'DYNAMIC_TABS/TAB_SET_ACTIVE';

/* Akcje uruchamiane na komponentach zakładek */
export const INIT = 'DYNAMIC_TAB/INIT';
export const INIT_TABLE_FINISH = 'DYNAMIC_TAB/INIT_TABLE_FINISH';
export const INIT_FINISH = 'DYNAMIC_TAB/INIT_FINISH';

export const SET_LEFT_PANEL_LOADING = 'DYNAMIC_TAB/SET_LEFT_PANEL_LOADING';
export const GET_LEFT_PANEL_DATA_SUCCESS = 'DYNAMIC_TAB/GET_LEFT_PANEL_DATA_SUCCESS';
export const GET_LEFT_PANEL_DATA_FAIL = 'DYNAMIC_TAB/GET_LEFT_PANEL_DATA_FAIL';

export const GET_DATA_SUCCESS = 'DYNAMIC_TAB/GET_DATA_SUCCESS';
export const GET_DATA_FAIL = 'DYNAMIC_TAB/GET_DATA_FAIL';

export const GET_DATA_NEXT_PAGE_START = 'DYNAMIC_TAB/GET_DATA_NEXT_PAGE_START';
export const GET_DATA_NEXT_PAGE_SUCCESS = 'DYNAMIC_TAB/GET_DATA_NEXT_PAGE_SUCCESS';
export const GET_DATA_NEXT_PAGE_FAIL = 'DYNAMIC_TAB/GET_NEXT_PAGE_FAIL';

export const SET_SELECTED = 'DYNAMIC_TAB/SET_SELECTED';
export const SET_PAGE = 'DYNAMIC_TAB/SET_PAGE';
export const SET_ORDER = 'DYNAMIC_TAB/SET_ORDER';
export const SET_EXPANDED = 'DYNAMIC_TAB/SET_EXPANDED';
export const SET_LOADING = 'DYNAMIC_TAB/SET_LOADING';
export const SET_SEARCH = 'DYNAMIC_TAB/SET_SEARCH';
export const SET_DETAILS_LOADING = 'DYNAMIC_TAB/SET_DETAILS_LOADING';

export const COLUMNS_SAVE_USER_SETUP_START = 'DYNAMIC_TAB/COLUMNS_SAVE_USER_SETUP_START';
export const COLUMNS_SAVE_USER_SETUP_SUCCESS = 'DYNAMIC_TAB/COLUMNS_SAVE_USER_SETUP_SUCCESS';

export const COLUMNS_GET_CONFIG_SUCCESS = 'DYNAMIC_TAB/COLUMNS_GET_CONFIG_SUCCESS';
export const COLUMNS_GET_CONFIG_FAIL = 'DYNAMIC_TAB/COLUMNS_GET_CONFIG_FAIL';

export const COLUMNS_CHANGE_SORTING = 'DYNAMIC_TAB/COLUMNS_CHANGE_SORTING';

export const FILTERS_GET_CONFIG_SUCCESS = 'DYNAMIC_TAB/FILTERS_GET_CONFIG_SUCCESS';
export const FILTERS_GET_CONFIG_FAIL = 'DYNAMIC_TAB/FILTERS_GET_CONFIG_FAIL';

export const FILTERS_SELECT_VALUES = 'DYNAMIC_TAB/FILTERS_SELECT_VALUES';
export const FILTERS_OPEN_CATEGORY = 'DYNAMIC_TAB/FILTERS_OPEN_CATEGORY';
export const FILTERS_CLOSE_CATEGORY = 'DYNAMIC_TAB/FILTERS_CLOSE_CATEGORY';

export const RECORD_GET_DETAILS_START = 'DYNAMIC_TAB/RECORD_GET_DETAILS_START';
export const RECORD_GET_DETAILS_FAIL = 'DYNAMIC_TAB/RECORD_GET_DETAILS_FAIL';
export const RECORD_GET_DETAILS_SUCCESS = 'DYNAMIC_TAB/RECORD_GET_DETAILS_SUCCESS';

export const FILTERS_REFRESH_VALUES_SUCCESS = 'DYNAMIC_TAB/FILTERS_REFRESH_VALUES_SUCCESS';
export const FILTERS_REFRESH_VALUES_FAIL = 'DYNAMIC_TAB/FILTERS_REFRESH_VALUES_FAIL';

export const REFRESH_DATA_START = 'DYNAMIC_TAB/REFRESH_DATA_START';
export const REFRESH_DATA_SUCCESS = 'DYNAMIC_TAB/REFRESH_DATA_SUCCESS';
export const REFRESH_DATA_FAIL = 'DYNAMIC_TAB/REFRESH_DATA_FAIL';

export const REFRESH_SELECTED_DATA_START = 'DYNAMIC_TAB/REFRESH_SELECTED_DATA_START';
export const REFRESH_SELECTED_DATA_SUCCESS = 'DYNAMIC_TAB/REFRESH_SELECTED_DATA_SUCCESS';
export const REFRESH_SELECTED_DATA_FAIL = 'DYNAMIC_TAB/REFRESH_SELECTED_DATA_FAIL';


export const SYNC_DATA_WITH_CACHE_START = 'DYNAMIC_TAB/SYNC_DATA_WITH_CACHE_START';
export const SYNC_DATA_WITH_CACHE_SUCCESS = 'DYNAMIC_TAB/SYNC_DATA_WITH_CACHE_SUCCESS';
export const SYNC_DATA_WITH_CACHE_FAIL = 'DYNAMIC_TAB/SYNC_DATA_WITH_CACHE_FAIL';

export const SET_DATA_AFTER_SORT = 'DYNAMIC_TAB/SET_DATA_AFTER_SORT';
export const SET_DATA_ATTENDANCE_LIST_AFTER_SORT = 'DYNAMIC_TAB/SET_DATA_ATTENDANCE_LIST_AFTER_SORT';